import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";

const initialValue = {
    featured_products: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                products_data: action.payload,
            }
        }
        case 'UPDATE_STATUS': {
            let newData = state.products_data.featured_products.map((pro) =>
                action.payload.data.id === pro.id ? action.payload.data : pro
            );
            let newState = {
                featured_products: newData
            }
            return {
                ...state,
                products_data: newState,
            }
        }
        case 'REMOVE_FEATURED': {
            let newData = state.products_data.featured_products.filter(pro => {
                return `${action.payload.product_id}` !== `${pro.id}`
            });
            let newState = {
                featured_products: newData
            }
            return {
                ...state,
                products_data: newState,
            }
        }
        default: {
            return state
        }
    }
}

const FeatureProductsContext = createContext({
    products_data: initialValue,
    getFeatureProductsData: () => {},
    changeProductStatus: () => {},
    make_featured: () => {},
    remove_featured: () => {},
    changeProductDelivery: () => {},
})

export const FeatureProductsProvider = ({settings, children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)

    const getFeatureProductsData = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/featured_products', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const changeProductStatus = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_status/${product_id}/${status}`, options);

            if(res.status === 200) {
                dispatch({
                    type: 'UPDATE_STATUS',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    const changeProductDelivery = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_delivery/${product_id}/${status}`, options);

            if(res.status === 200) {
                dispatch({
                    type: 'UPDATE_STATUS',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    const make_featured = async (product_id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/make_featured/${product_id}`, options);

            if(res.status === 200) {
                dispatch({
                    type: 'MAKE_FEATURED',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }


    const remove_featured = async (product_id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/remove_featured/${product_id}`, options);

            if(res.status === 200) {
                dispatch({
                    type: 'REMOVE_FEATURED',
                    payload: res.data
                })
            }else{
                alert(JSON.stringify(res.data));
            }

        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getFeatureProductsData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.products_data === undefined) {
        return <MatxLoading />
    }

    return (
        <FeatureProductsContext.Provider
            value={{
                products_data: state.products_data,
                getFeatureProductsData,
                changeProductStatus,
                make_featured,
                remove_featured,
                changeProductDelivery,
            }}
        >
            {children}
        </FeatureProductsContext.Provider>
    )
}

export default FeatureProductsContext
